import { LoadingStates, isNorthstarBrand } from '@pb/utils'

import { EXTERNAL_ROUTES, ACCOUNT_ROUTES } from 'App/constants'

import { MENU_ITEM_KEYS, MENU_SECTION_KEYS, NEW_MENU_ITEM_KEYS, NEW_MENU_KEYS } from '../constants'
import { UserMenuState } from './types'

const userMenu: UserMenuState = {
  reviewItems: {
    isLoading: false,
    isLoadingFailed: false,
    isRequested: false,
    number: 0,
  },
  userMenus: [
    {
      key: MENU_SECTION_KEYS.account,
      heading: 'hub.account.title',
      menuItems: [
        {
          key: MENU_ITEM_KEYS.purchases,
          title: 'my.account.menu.purchases',
          to: ACCOUNT_ROUTES.Purchases?.path,
          isDisabled: false,
          isVisible: true,
          isRoute: true,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.reviewItems,
          title: 'text.account.reviews',
          to: EXTERNAL_ROUTES.rateAndReview,
          isDisabled: true,
          isVisible: false,
          isRoute: false,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.pointsHistoryPage,
          title: 'php.section.title.my.account',
          to: ACCOUNT_ROUTES.PointsHistory?.path,
          isDisabled: false,
          isVisible: false,
          isRoute: true,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.paymentCredits,
          title: 'account.payment.info.title',
          to: EXTERNAL_ROUTES.payments,
          isDisabled: false,
          isVisible: true,
          isRoute: false,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.hmxklarna,
          title: 'account.klarna.link',
          to: ACCOUNT_ROUTES.HMPay?.path,
          isDisabled: false,
          isVisible: false,
          isRoute: true,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.hmxklarnaActivation,
          title: 'account.klarna.link',
          to: ACCOUNT_ROUTES.PayLaterStoreActivationInfo?.path,
          isDisabled: false,
          isVisible: false,
          isRoute: true,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.mySettings,
          title: ACCOUNT_ROUTES.Settings?.title,
          to: ACCOUNT_ROUTES.Settings?.path,
          isDisabled: false,
          isVisible: true,
          isRoute: true,
          shouldShowBadge: false,
        },
      ],
    },
    {
      heading: 'hub.club.help',
      key: MENU_SECTION_KEYS.help,
      menuItems: [
        {
          key: MENU_ITEM_KEYS.clubInfoPage,
          title: 'account.membership.info',
          to: EXTERNAL_ROUTES.clubInfoPage,
          isDisabled: false,
          isVisible: false,
          isRoute: false,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.customerService,
          title: 'account.contact.us',
          to: EXTERNAL_ROUTES.customerService,
          isDisabled: false,
          isVisible: true,
          isRoute: false,
          shouldShowBadge: false,
        },
        {
          key: MENU_ITEM_KEYS.logout,
          title: 'account.sign.out',
          to: EXTERNAL_ROUTES.logout,
          classNames: 'logout',
          isDisabled: false,
          isVisible: true,
          isRoute: false,
          shouldShowBadge: false,
          shouldHideChevron: true,
        },
      ],
    },
  ],
  newUserMenus: [
    {
      key: NEW_MENU_ITEM_KEYS.purchases,
      newKey: NEW_MENU_KEYS.myorders,
      title: 'account.menu.purchases',
      newTitle: 'myaccount.menu.myorders.title',
      subText: 'myaccount.menu.myorders.subtext',
      to: ACCOUNT_ROUTES.Purchases?.path,
      isDisabled: false,
      isVisible: true,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: 'DeliveryIcon',
      badgeText: 'account.accessibility.active.order',
      badgeShape: isNorthstarBrand ? 'square' : 'default',
    },
    {
      key: NEW_MENU_ITEM_KEYS.pointshistory,
      newKey: NEW_MENU_KEYS.mypoints,
      title: 'account.menu.pointshistory',
      newTitle: 'myaccount.menu.mypoints.title',
      subText: 'myaccount.menu.mypoints.subtext',
      to: ACCOUNT_ROUTES.PointsHistory?.path,
      isDisabled: false,
      isVisible: false,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'WelcomePointsIcon' : 'MyPointsIcon',
    },
    {
      key: NEW_MENU_ITEM_KEYS.mysettings,
      newKey: NEW_MENU_KEYS.accountdetails,
      title: 'account.menu.mysettings',
      newTitle: 'myaccount.menu.accountdetails.title',
      subText: 'myaccount.menu.accountdetails.subtext',
      to: ACCOUNT_ROUTES.Settings?.path,
      isDisabled: false,
      isVisible: true,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: 'SettingsIcon',
      badgeText: 'account.accessibility.complete.information',
      badgeShape: isNorthstarBrand ? 'square' : 'default',
    },
    {
      key: NEW_MENU_ITEM_KEYS.payment,
      newKey: NEW_MENU_KEYS.paymentinformation,
      title: 'account.menu.payment',
      newTitle: 'myaccount.menu.paymentinformation.title',
      subText: 'myaccount.menu.paymentinformation.subtext',
      to: EXTERNAL_ROUTES.payments,
      isDisabled: false,
      isVisible: true,
      isRoute: false,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: 'PaymentIcon',
    },
    {
      key: NEW_MENU_ITEM_KEYS.info,
      newKey: NEW_MENU_KEYS.membership,
      title: 'account.menu.info',
      newTitle: 'myaccount.menu.membership.title',
      subText: 'myaccount.menu.membership.subtext',
      to: EXTERNAL_ROUTES.clubInfoPage,
      isDisabled: false,
      isVisible: false,
      isRoute: false,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'PersonIcon' : 'AccountDefaultIcon',
    },
    {
      key: NEW_MENU_ITEM_KEYS.review,
      newKey: NEW_MENU_KEYS.rateandreview,
      title: 'account.menu.review',
      newTitle: 'myaccount.menu.rateandreview.title',
      subText: 'myaccount.menu.rateandreview.subtext',
      to: EXTERNAL_ROUTES.rateAndReview,
      isDisabled: true,
      isVisible: false,
      isRoute: false,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: 'RatingInactiveIcon',
      number: 0,
    },

    {
      key: NEW_MENU_ITEM_KEYS.inviteafriend,
      newKey: NEW_MENU_KEYS.inviteafriend,
      title: 'account.menu.inviteafriend',
      newTitle: 'myaccount.menu.inviteafriend.title',
      subText: 'myaccount.menu.inviteafriend.subtext',
      newTagText: 'myaccount.menu.new.title',
      to: ACCOUNT_ROUTES.InviteFriend?.path,
      isDisabled: false,
      isVisible: false,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'InviteAFriendIcon' : 'InviteAFriendIconNS',
    },
    {
      key: NEW_MENU_ITEM_KEYS.klarna,
      newKey: NEW_MENU_KEYS.paymentsklarna,
      title: 'account.menu.klarna',
      newTitle: 'myaccount.menu.paymentsklarna.title',
      subText: 'myaccount.menu.paymentsklarna.subtext',
      to: ACCOUNT_ROUTES.HMPay?.path,
      isDisabled: false,
      isVisible: false,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'PayLaterIcon' : 'PayLaterIconNS',
    },
    {
      key: NEW_MENU_ITEM_KEYS.customerservice,
      newKey: NEW_MENU_KEYS.customerservice,
      title: 'account.contact.us',
      newTitle: 'myaccount.menu.customerservice.title',
      subText: 'myaccount.menu.customerservice.subtext',
      to: EXTERNAL_ROUTES.customerService,
      isDisabled: false,
      isVisible: true,
      isRoute: false,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'CustomerServiceIcon' : 'CustomerServiceIconNS',
    },
    {
      key: NEW_MENU_ITEM_KEYS.signout,
      newKey: NEW_MENU_KEYS.signout,
      title: 'account.sign.out',
      newTitle: 'myaccount.menu.signout.title',
      subText: 'myaccount.menu.signout.subtext',
      to: EXTERNAL_ROUTES.logout,
      classNames: 'logout',
      isDisabled: false,
      isVisible: true,
      isRoute: false,
      shouldShowBadge: false,
      shouldHideChevron: true,
      icon: !isNorthstarBrand ? 'NewWindowIcon' : 'LogoutIcon',
    },
    {
      key: NEW_MENU_ITEM_KEYS.helpus,
      newKey: NEW_MENU_KEYS.helpusimprove,
      title: 'account.menu.helpus',
      newTitle: 'myaccount.menu.helpusimprove.title',
      subText: 'myaccount.menu.helpusimprove.subtext',
      to: ACCOUNT_ROUTES.HelpUs?.path,
      isDisabled: false,
      isVisible: true,
      isRoute: true,
      shouldShowBadge: false,
      shouldHideChevron: isNorthstarBrand,
      icon: !isNorthstarBrand ? 'HelpUsImproveIcon' : 'CustomerServiceFeedbackIcon',
    },
  ],
  loadingState: LoadingStates.NotLoaded,
}

export default userMenu
